import { Tag } from "antd";
import moment from "moment";
import React from "react";
import { GatewayColor, GatewayName } from "../../config/gateway";

export default (countryList, gatewayList) => [
  {
    title: "วันที่",
    dataIndex: "created",
    render: (date) => {
      const datetime = new Date(date.Time);
      return moment(datetime).format("DD/MM/YYYY");
    },
  },
  {
    title: "ประเทศ",
    dataIndex: "region_code",
    render: (text) => {
      let country = "";
      if (text === "NONE") country = "Default";
      const findCountry = countryList.find((row) => row.region_code === text);
      if (findCountry) {
        country = findCountry["name"];
      }

      return <span style={{ fontWeight: "bold" }}>{country}</span>;
    },
  },
  {
    title: "เหตุการณ์",
    dataIndex: "event",
    render: (text) => {
      const colors = {
        updated: "#2db7f5",
        created: "#87d068",
        disabled: "#c2c2d6",
        enabled: "#ffc266",
        deleted: "#f10000",
      };
      return <Tag color={colors[text]}>{text.toUpperCase()}</Tag>;
    },
  },
  // {
  //   title: "รหัสสมาชิก",
  //   dataIndex: "member_id",
  //   render: (text) => {
  //     return text == 0 ? "ระบบ" : text;
  //   },
  // },
  {
    title: "กระทำโดย",
    dataIndex: "created_by",
    render: (text, record) => {
      if (text === 1) {
        return "Admin System";
      }
      return record.admin_name || "-";
    },
  },
  {
    title: "Vendors",
    dataIndex: "gateway",
    width: "30%",
    render: (text) => {
      const rtn = [];
      text = String(text);
      const arrayIds = text.split(",");
      for (const [i, id] of Object.entries(arrayIds)) {
        const gateway = gatewayList.find((row) => row.id === Number(id));
        if (!gateway) {
          continue;
        }
        rtn.push(
          <Tag key={i} color={GatewayColor(gateway.key_name)}>
            {GatewayName(gateway.key_name)}
          </Tag>
        );
      }

      return rtn;
    },
  },
];



// WEBPACK FOOTER //
// ./src/containers/GatewayCountryLogs/column.js